import addToCartReducer from "../redux/addToCart/addToCartReducer";

const myLogger = (store) => (next) => (action) =>{
    console.log(`Action: ${JSON.stringify(action)}`);
    console.log(`Before: ${JSON.stringify(store.getState())}`);

    const upcommingState = [action].reduce(addToCartReducer, store.getState());
    console.log(`Upcomming: ${JSON.stringify(upcommingState)}`);
    //pass action
    return next(action);
} 

export default myLogger;